import Announcement from '../components/Announcement';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const ContactUsPage = () => {
  return (
    <div>
      <Announcement />
      <Navbar />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default ContactUsPage;
